import Gauge from '@/components/Gauge';

import { Text } from '@simplywallst/ui-core';

import { formatterPercentage } from '@/utilities/format';

import { Card } from '../Card';

export interface Props {
  portfolioValue: number | null;
  marketValue: number | null;
}

export const ReturnOnAssets = ({ portfolioValue, marketValue }: Props) => {
  return (
    <Card
      title="Return on Assets"
      description={
        <Text color="inherit" typography="xSmall">
          This chart compares your portfolio's Return on Assets (ROA) to the
          market average, highlighting efficiency in using assets to generate
          earnings. ROA reflects a company's profitability from its assets. A
          higher ROA indicates better asset utilization for income generation,
          while a lower ROA suggests less efficiency. Use this comparison to
          gauge your portfolio's financial health and operational efficiency
          relative to the market.{' '}
          <a
            href="https://support.simplywall.st/hc/en-us/articles/9423775242383-Understanding-the-New-Portfolio-Analysis-Calculations"
            rel="noreferrer nofollow"
            target="_blank"
          >
            Learn more
          </a>
        </Text>
      }
    >
      <Gauge
        keys={['portfolio', 'market']}
        entities={{
          portfolio: portfolioValue,
          market: marketValue,
        }}
        numTicks={5}
        title="ROA Ratio"
        from={0}
        to={0.1}
        formatter={formatterPercentage}
      />
    </Card>
  );
};
